export const isNumber = (value: any): boolean => {
  return value !== null && !isNaN(value) ? true : false;
};

export const toNumber = (value: any): number => {
  return Number(value) || 0;
};

export const toPrice = (value: any, isRoundUp: boolean = true): number => {
  // const val = isRoundUp
  //   ? Math.ceil(toNumber(value) * 100)
  //   : Math.floor(toNumber(value) * 100);
  return Math.round(toNumber(value) * 100) / 100;
};

export const toPercent = (value: any, isRoundUp: boolean = true): number => {
  const val = isRoundUp
    ? Math.round(toNumber(value) * 100)
    : toNumber(value) * 100;
  return val / 100;
};

export const formatNumber = (
  value: number | bigint | null | undefined | string,
  {
    decimals = 0,
    forcePlusSuffix = false,
    useAbbreviation = true,
    fallback = "-",
    locale = "en-US",
  }: {
    decimals?: number;
    forcePlusSuffix?: boolean;
    useAbbreviation?: boolean;
    fallback?: string;
    locale?: string;
  } = {},
): string => {
  if (value === null || value === undefined) {
    return fallback;
  }

  let num = toNumber(value);
  let index = 0;
  const abbreviations = ["", "k", "m", "b", "t"];

  if (useAbbreviation) {
    while (num >= 1000 && index < abbreviations.length - 1) {
      num /= 1000;
      index++;
    }
  }

  const suffix =
    forcePlusSuffix || (Number(num.toFixed(decimals)) < num && index > 0)
      ? "+"
      : "";

  return `${Number(num.toFixed(decimals)).toLocaleString(locale)}${abbreviations[index]}${suffix}`;
};

export const formatCurrency = (
  amount: number | bigint | null | undefined | string,
  options?: { locales?: string | string[]; fallback?: string },
  IntlOptions?: Intl.NumberFormatOptions,
) => {
  const DEFAULT_FALLBACK = "-";
  const DEFAULT_LOCALES = "en-US";

  if (amount === null || amount === undefined) {
    return options?.fallback ?? DEFAULT_FALLBACK;
  }

  const value = toNumber(amount);

  return Intl.NumberFormat(options?.locales ?? DEFAULT_LOCALES, {
    currency: "USD",
    style: "currency",
    ...IntlOptions,
  }).format(value);
};

export const formatPercent = (value: any, decimals = 2): string => {
  if (typeof value === "undefined" || value === null) {
    return "-";
  }
  const percent = Number(toNumber(value).toFixed(decimals));
  if (!isFinite(percent)) {
    return `∞%`;
  }
  return `${percent < 0 ? "-" : ""} ${Math.abs(percent).toFixed(decimals)}%`.trim();
};

export const capitalize = (value: any) => {
  return String(value).charAt(0).toUpperCase() + String(value).slice(1);
};

export const capitalizeFirstLetterOfEveryWord = (value: any) => {
  const str = String(value);
  if (str.length === 0) return str;
  const words = str.split(" ");
  const capitalizedWords = words.map((word) => capitalize(word));
  return capitalizedWords.join(" ");
};
